/**
 * 차트 관련 유틸리티 함수들
 */
/**
 * 고유한 ID를 생성합니다
 * @param prefix - ID 앞에 붙을 접두사
 * @returns 고유한 ID 문자열
 */
export function generateUniqueId(prefix = '') {
    const randomId = Math.random().toString(36).substring(2, 11);
    return prefix ? `${prefix}_${randomId}` : randomId;
}
/**
 * 차트 ID를 생성합니다
 * @returns 고유한 차트 ID 문자열
 */
export function generateChartId() {
    return `chart-${Date.now()}-${Math.random().toString(36).substring(2, 11)}`;
}
/**
 * 구독 ID를 생성합니다
 * @param symbol - 심볼명
 * @returns 고유한 구독 ID 문자열
 */
export function generateSubscriptionId(symbol) {
    return `${symbol}_${Date.now()}_${Math.random().toString(36).substring(2, 11)}`;
}
/**
 * 차트 컨테이너 ID를 생성합니다
 * @param chartId - 사용자 지정 차트 ID (선택사항)
 * @returns TradingView 컨테이너 ID
 */
export function generateContainerId(chartId) {
    return chartId ? `tv_chart_container_${chartId}` : `tv_chart_container_${generateUniqueId()}`;
}
/**
 * 차트 매니저 인스턴스 ID를 생성합니다
 * @returns 차트 매니저 인스턴스 ID
 */
export function generateChartManagerId() {
    return `chart_${generateUniqueId()}`;
}
/**
 * Timeframe을 Interval로 변환합니다
 * @param timeframe - 시간대 문자열 (예: "1", "5", "60", "240", "1D", "1W")
 * @returns TradingView interval 문자열 (예: "1", "5", "60", "240", "1D", "1W")
 * @description
 * CHART_TIMEFRAMES의 value는 이미 interval 형식이므로, 대부분의 경우 그대로 반환됩니다.
 * 숫자 문자열이나 interval 형식('1D', '1W' 등)은 그대로 반환하고,
 * 알 수 없는 형식은 기본값 '1'을 반환합니다.
 */
export function timeframeToInterval(timeframe) {
    if (!timeframe) {
        return '1';
    }
    // 숫자 문자열인 경우 그대로 반환 (이미 interval 형식)
    if (/^\d+$/.test(timeframe)) {
        return timeframe;
    }
    // 이미 interval 형식인 경우 (예: "1D", "1W", "1M") 대문자로 정규화하여 반환
    if (/^\d+[DWM]$/i.test(timeframe)) {
        return timeframe.toUpperCase();
    }
    // 알 수 없는 형식인 경우 기본값 반환
    return '1';
}
//# sourceMappingURL=ChartUtils.js.map